// How we display currencies that shouldn't appear as their raw ISO code. Display only —
// payment gateways, Apple Pay etc. must keep receiving the ISO code itself.
// `spaced` follows each currency's guideline on whether a space separates the symbol
// from the amount ("$ 45.00" vs "$45.00").
interface CurrencyDisplay {
  symbol: string;
  spaced: boolean;
}

const CURRENCY_DISPLAY: Record<string, CurrencyDisplay> = {
  USD: { symbol: '$', spaced: false },
  EUR: { symbol: '€', spaced: false },
  GBP: { symbol: '£', spaced: false },
  MXN: { symbol: 'Peso', spaced: true },
  ZAR: { symbol: 'R', spaced: false },
  PKR: { symbol: 'Rs', spaced: true },
  // UAE Dirham sign. No system font has this glyph yet, so it's rendered by the
  // single-glyph 'DirhamAED' font declared in styles.scss.
  AED: { symbol: '⃃', spaced: true },
};

export function currencySymbol(code: string): string {
  return CURRENCY_DISPLAY[code]?.symbol ?? code;
}

// Currencies without an entry show their ISO code, which always needs the space ("SAR 12.00").
export function formatPrice(code: string, price: string): string {
  const separator = CURRENCY_DISPLAY[code]?.spaced === false ? '' : ' ';
  return currencySymbol(code) + separator + price;
}
